export const NoAccess = () => {
  return (
    <div>
      <h1>No Access</h1>
    </div>
  )
}
